export const PREPAID_CATALOGUE = {
    version: '2026-10-v2',
    packages: [
        { packageId: 'min100', currency: 'PLN', seconds: 100 * 60, enabled: true, defaultTriggerSeconds: 30 * 60 },
        { packageId: 'min300', currency: 'PLN', seconds: 300 * 60, enabled: true, defaultTriggerSeconds: 60 * 60 },
        { packageId: 'min500', currency: 'PLN', seconds: 500 * 60, enabled: true, defaultTriggerSeconds: 100 * 60 },
        { packageId: 'min1000', currency: 'PLN', seconds: 1000 * 60, enabled: true, defaultTriggerSeconds: 200 * 60 },
        { packageId: 'min100', currency: 'EUR', seconds: 100 * 60, enabled: true, defaultTriggerSeconds: 30 * 60 },
    ],
    defaults: { autoPackageId: 'min100', triggerSeconds: 30 * 60 },
};
/**
 * TEST FIXTURES ONLY: the doc 57 offer — 149 PLN/month platform fee and four
 * packages. They exist so tests and the Stripe sandbox runbook have something
 * concrete; nothing in production code reads them (Stripe owns the prices).
 */
export const TEST_PRICE_FIXTURES = {
    platformMonthlyNetMinor: { PLN: 14900 },
    packageNetMinor: { min100: { PLN: 7900 }, min300: { PLN: 21900 }, min500: { PLN: 34900 }, min1000: { PLN: 64900 } },
};
export function findPackage(catalogue, packageId, currency) {
    return catalogue.packages.find((p) => p.packageId === packageId && p.currency === currency && p.enabled) ?? null;
}
/**
 * Parse `STRIPE_TOPUP_PRICE_IDS` — `min100.PLN=price_…;min100.EUR=price_…`.
 *
 * One param rather than one per package so a new package is a catalogue entry
 * plus a config value, never a new deploy-time parameter declaration. Malformed
 * entries are dropped (and so cannot be bought), never guessed at.
 */
export function parseTopupPriceIds(raw) {
    const out = new Map();
    for (const part of raw.split(/[;,\n]/)) {
        const m = /^\s*([a-z0-9_-]+)\.(PLN|EUR)\s*=\s*(price_[A-Za-z0-9]+)\s*$/.exec(part);
        if (m)
            out.set(`${m[1]}.${m[2]}`, m[3]);
    }
    return out;
}
export const topupPriceKey = (packageId, currency) => `${packageId}.${currency}`;
//# sourceMappingURL=catalogue.js.map